var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-list-icon",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require("../../../../assets/images/icon_lb.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }